import { CanDeactivateFn } from '@angular/router';
import { DeActivatable } from '../interfaces/de-activatable.interface';
import { Observable } from 'rxjs';

export const leavePageGuard: CanDeactivateFn<DeActivatable> = (
  component: DeActivatable
): Observable<boolean> | Promise<boolean> | boolean => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
